var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"emd-panel__section"},[_c('emd-text',{staticClass:"emd-panel__block",attrs:{"size":"section"}},[_vm._v(" "+_vm._s(_vm.$t('keys.api-version'))+" ")]),_c('emd-text',{staticClass:"eu-display_inline-block emd-panel__block eu-basis_4",attrs:{"size":"caption"}},[_vm._v(" V5.0 ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }